
  import { css } from 'lit';
  export const styles = css`:host{--border-radius: var(--ig-avatar-border-radius, 0.25rem);--ig-theme: bootstrap;--ig-theme-variant: light}`;
  